import React from 'react';

const ClientSkeleton = () => (
  <>
    <style>{`
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
      .skeleton-pulse {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      }
    `}</style>
    <main className="p-6 lg:p-10 space-y-8">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-2">
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-xl bg-gray-200 skeleton-pulse" />
          <div className="space-y-2">
            <div className="h-8 w-64 bg-gray-200 rounded skeleton-pulse" />
            <div className="h-4 w-80 bg-gray-200 rounded skeleton-pulse" />
          </div>
        </div>
        <div className="h-14 w-36 bg-gray-200 rounded-xl skeleton-pulse" />
      </div>

      {/* Social Networks Card */}
      <div className="rounded-lg border bg-white p-6 space-y-6">
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-xl bg-gray-200 skeleton-pulse" />
          <div className="space-y-2">
            <div className="h-6 w-40 bg-gray-200 rounded skeleton-pulse" />
            <div className="h-4 w-64 bg-gray-200 rounded skeleton-pulse" />
          </div>
        </div>
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="flex items-center justify-between py-4 border-b">
              <div className="space-y-2 flex-1">
                <div className="h-5 w-32 bg-gray-200 rounded skeleton-pulse" />
                <div className="h-4 w-56 bg-gray-200 rounded skeleton-pulse" />
              </div>
              <div className="h-6 w-11 bg-gray-200 rounded-full skeleton-pulse" />
            </div>
          ))}
        </div>
      </div>

      {/* Content Strategy Card */}
      <div className="rounded-lg border bg-white p-6 space-y-6">
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-xl bg-gray-200 skeleton-pulse" />
          <div className="space-y-2">
            <div className="h-6 w-44 bg-gray-200 rounded skeleton-pulse" />
            <div className="h-4 w-72 bg-gray-200 rounded skeleton-pulse" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[1, 2].map((i) => (
            <div key={i} className="space-y-3">
              <div className="h-5 w-28 bg-gray-200 rounded skeleton-pulse" />
              <div className="h-10 bg-gray-200 rounded skeleton-pulse" />
            </div>
          ))}
        </div>
      </div>
    </main>
  </>
);

export default ClientSkeleton;
